export class InvSamplingEntity{
    id:number;
    cyclicId:number;
    value:string;
    active:boolean;

    constructor(){}
}